<template>
  <v-text-field
    v-if="showReference"
    outlined
    autocomplete="off"
    clearable
    label="Order Reference (Optional)"
    name="email"
    prepend-inner-icon="mdi-text"
    type="text"
    v-model="custRef"
    hint="e.g. Customer Order No."
    counter
    maxlength="20"
  />
</template>

<script>
export default {
  props: {
    template: null,
    order: null
  },

  data() {
    return {
      limit: 3,

      custRef: ""
    };
  },

  computed: {
    showReference() {
      let showSelector = false;
      let config = this.$store.getters.retrieveAllConfigs
        .orders_delivery_reference_show;

      if (
        config == 1 ||
        (config == 2 && this.$store.getters.retrieveIsCashCustomer) ||
        (config == 2 && this.$store.getters.retrieveIsCncCustomer) ||
        (config == 3 &&
          !this.$store.getters.retrieveIsCashCustomer &&
          !this.$store.getters.retrieveIsCncCustomer)
      ) {
        showSelector = true;
      }

      return showSelector;
    }
  },

  activated() {
    console.log("-- Activated Refererence");
    console.log(this.order.cust_ref);
    console.log(this.template);

    if (this.order && this.template != true) {
      this.custRef = this.order.cust_ref;
    } else {
      this.custRef = "";
    }
  },

  watch: {
    custRef() {
      this.$emit("input", this.custRef);
    }
  },

  methods: {}
};
</script>

<style lang="sass" scoped>
</style>